import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './Card';
export function Reviews() {
  const reviews = [{
    name: 'Michelle Corey',
    text: "My husband and I had our roof and gutters replaced by Texas Direct. I usually don't write reviews, but I had to share the GREAT experience we had. We are very picky people when it comes to spending our hard earned money on big ticket items, and they did not disappoint."
  }, {
    name: 'David T.',
    text: 'Incredible service from start to finish. They handled the entire insurance process after the hail storm. The crew was fast, respectful of our property, and cleaned up perfectly. Highly recommend Texas Direct to anyone in DFW.'
  }, {
    name: 'Sarah Jenkins',
    text: 'Honest and transparent pricing. They came out the same day I called for an inspection, showed me photos of the damage, and walked me through the options. The new roof looks amazing and gives us total peace of mind.'
  }];
  return <section id="reviews" className="py-20 bg-tx-light" data-id="element-233">
      <div className="container mx-auto px-4" data-id="element-234">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-235">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-tx-deep mb-4 tracking-tight" data-id="element-236">
            What Our Clients Are Saying
          </h2>
          <div className="w-20 h-1.5 bg-tx-red mx-auto rounded-full mb-6" data-id="element-237"></div>
          <a href="#" className="inline-flex items-center gap-2 text-tx-navy font-bold hover:text-tx-red transition-colors" data-id="element-238">
            Read all 450+ 5-Star Reviews
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-239">
          {reviews.map((review, index) => <Card key={index} className="border-0 shadow-md hover:shadow-lg transition-shadow rounded-xl h-full" data-id="element-240">
              <CardContent className="p-8 flex flex-col h-full" data-id="element-241">
                <div className="flex gap-1 mb-6" data-id="element-242">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-243" />)}
                </div>
                <p className="text-tx-body leading-relaxed mb-8 flex-grow italic" data-id="element-244">
                  "{review.text}"
                </p>
                <div className="font-bold text-tx-deep" data-id="element-245">{review.name}</div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}